import { render, staticRenderFns } from "./PosChooseProduct.vue?vue&type=template&id=7ea583df&scoped=true&"
import script from "./PosChooseProduct.vue?vue&type=script&lang=js&"
export * from "./PosChooseProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea583df",
  null
  
)

export default component.exports